// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"4f8bf77a","700":"8277cbe5"}[chunkId] + ".chunk.css";
};